import styled, { css } from 'styled-components';

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover .tooltip-text {
    visibility: visible;
  }

  .tooltip-text {
    visibility: hidden;
    background-color: rgba(0, 0, 0, 0.75);
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 4px;
    position: absolute;
    z-index: 100;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    white-space: nowrap;
    font-family: 'IBM Plex Sans', Helvetica;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  
  > *:last-child {
    margin-left: 12px;
  }
`;

export const ButtonWithText = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #fff;
  border: 1px solid var(--color-purple-300, #7200E0);
  border-radius: 25px;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4b464f;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f2f1f380;
    border-color: #51009f;
  }

  &:active:not(:disabled) {
    background-color: #e8e0f0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ButtonIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const ButtonText = styled.span`
  white-space: nowrap;
`;

export const Buttons = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 6px 7px;
  position: relative;
  border-radius: 6px;
  cursor: pointer;
`;

export const Arrowright = styled.img`
  position: relative;
`;

export const DeleteButtonContainer = styled.div`
  display: flex;
  padding: 6px 0px;
  align-items: flex-start;
  gap: 10px;
`;

export const TemplateTooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover .template-tooltip {
    opacity: 1;
    visibility: visible;
  }
`;

export const TemplateButton = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 25px;
  cursor: not-allowed;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4b464f;
  transition: all 0.2s ease;
  pointer-events: none;

  &:hover {
    background-color: #fff;
    border-color: #d0d0d0;
  }
`;

export const TemplateTooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
  pointer-events: none;
`;


